import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'page-schedule',
  templateUrl: './schedule.component.html',
  styleUrls: ['./schedule.component.scss'],
})
export class PractitionerScheduleComponent implements OnInit {
  public title = 'Agendar';

  constructor(private readonly router: Router) {}

  ngOnInit(): void {
    this.goToUrl('/medico/agendar/especialistas/exame');
  }

  goToUrl(page: string) {
    this.router.navigate([page]);
  }
}
